import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider.js'
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../../components/simple/text/Text'
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter'

import { Bar } from 'react-chartjs-2'

import LocalStorageService from '../../../services/LocalStorageService'

import { backgroundColours, borderColours } from '../common/colours.js'
import ActionList from '../../../components/compound/actionList/ActionList.js'
const InterventionReport = (props) => {
  const navigate = useNavigate()

  const [totalDurationPhysicalIntervention, setTotalDurationPhysicalIntervention] = useState(0)
  const [totalDurationPhysicalInterventionLabel, setTotalDurationPhysicalInterventionLabel] = useState('')
  const [averageDurationPhysicalIntervention, setAverageDurationPhysicalIntervention] = useState(0)
  const [averageDurationPhysicalInterventionLabel, setAverageDurationPhysicalInterventionLabel] = useState('')


  const [incidentDamageCountData, setIncidentDamageCountData] = useState([])
  const [commonInterventions, setCommonInterventions] = useState([])
  const [commonTechniques, setCommonTechniques] = useState([])
  const [commonPhysicalTechniques, setCommonPhysicalTechniques] = useState([])
  const [commonDeescalationTechniques, setCommonDeescalationTechniques] = useState([])
  const [breathingMonitoredByStudentGraph, setBreathingMonitoredByStudentGraph] = useState([])
  const [breathingMonitoredByYearGroupGraph, setBreathingMonitoredByYearGroupGraph] = useState([])
  const [breathingMonitoredByStudentGroupGraph, setBreathingMonitoredByStudentGroupGraph] = useState([])
  const [numIncidentsRestrictedInterventionUsed, setNumIncidentsRestrictedInterventionUsed] = useState(0)
  const [relatedIncidents, setRelatedIncidents] = useState([]);

  const terms = LocalStorageService.get('terms')

  // Demo Data
  const studentDataWithBreathingMonitored = {
    labels: breathingMonitoredByStudentGraph[1],
    datasets: [
      {
        label: '# of Votes',
        data: breathingMonitoredByStudentGraph[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const yeargroupData = {
    labels: breathingMonitoredByYearGroupGraph[1],
    datasets: [
      {
        label: '# of Votes',
        data: breathingMonitoredByYearGroupGraph[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const studentgroupData = {
    labels: breathingMonitoredByStudentGroupGraph[1],
    datasets: [
      {
        label: '# of Votes',
        data: breathingMonitoredByStudentGroupGraph[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const damageReportChartData = {
    labels: incidentDamageCountData[1],
    datasets: [
      {
        // label: '# of Incidents',
        data: incidentDamageCountData[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const printScreen = () => {
    window.print()
  }

  useEffect(() => {
    // Map the API data in props.reportData into the relevant datasets

    // Common Interventions
    if (props?.reportData?.commonIntervention) {
      let commonIntervention = props?.reportData?.commonIntervention
      // sort by count desc
      if (commonIntervention?.length) commonIntervention.sort((a, b) => (a.count < b.count) ? 1 : -1) 
      
      setCommonInterventions(commonIntervention.map((data) => {
        return {
          title: data.response + ' (' + data.count + ')',
          key: 'location',
          response: data.response
        }
      }))
    }

    // Common Techniques
    if (props?.reportData?.commonTechnique) {
      let commonTechnique = props?.reportData?.commonTechnique

      if (commonTechnique?.length) commonTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1) 
      
      setCommonTechniques(commonTechnique.map((data) => {
        return {
          title: data.response + ' (' + data.count + ')',
          key: data.response,
          response: null,
          operator: 'has'
        }
      }))
    }

    // Common Techniques
    if (props?.reportData?.commonPhysicalTechnique) {
      let commonPhysicalTechnique = props?.reportData?.commonPhysicalTechnique
      if (commonPhysicalTechnique?.length) commonPhysicalTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1)
      commonPhysicalTechnique = commonPhysicalTechnique.map((data) => {
        // data.questionkey = data.questionkey + ' (' + data.count + ')'
        // return data
        return {
          title: data.questionkey + ' (' + data.count + ')',
          key: data.questionkey,
          response: null,
          operator: 'has'
        }
      }) 
      setCommonPhysicalTechniques(commonPhysicalTechnique)
    }

    // Common Techniques
    if (props?.reportData?.commonDeescalationTechnique) {
      let commonDeescalationTechnique = props?.reportData?.commonDeescalationTechnique
      if (commonDeescalationTechnique?.length) commonDeescalationTechnique.sort((a, b) => (a.count < b.count) ? 1 : -1)
      commonDeescalationTechnique = commonDeescalationTechnique.map((data) => {
        // data.questionkey = data.questionkey + ' (' + data.count + ')'
        // return data
         return {
          title: data.questionkey + ' (' + data.count + ')',
          key: data.questionkey,
          response: null,
          operator: 'has'
        }
      }) 
      setCommonDeescalationTechniques(commonDeescalationTechnique)
    }

    // Average Duration Physical Intervention
    if (props?.reportData?.averageDurationPhysicalIntervention !== undefined) {
      const averageDurationPhysicalIntervention = props?.reportData?.averageDurationPhysicalIntervention
      if (averageDurationPhysicalIntervention?.value?.[0]?.average) {

        // convert minutes to a string with minutes and seconds
        const averageDurationPhysicalInterventionValue = parseFloat(averageDurationPhysicalIntervention?.value?.[0]?.average)
        const averageDurationPhysicalInterventionTotalSeconds = Math.floor(averageDurationPhysicalInterventionValue * 60)
        const averageDurationPhysicalInterventionMinutes = Math.floor(averageDurationPhysicalInterventionTotalSeconds / 60)
        const averageDurationPhysicalInterventionSeconds = averageDurationPhysicalInterventionTotalSeconds % 60
        const newLabel = averageDurationPhysicalInterventionMinutes + 'm ' + averageDurationPhysicalInterventionSeconds + 's'
        setAverageDurationPhysicalInterventionLabel(newLabel)

        setAverageDurationPhysicalIntervention(newLabel)
      }
    }

    // Average Duration Physical Intervention
    if (props?.reportData?.totalDurationPhysicalIntervention !== undefined) {
      const totalDurationPhysicalIntervention = props?.reportData?.totalDurationPhysicalIntervention
      if (totalDurationPhysicalIntervention?.value?.[0]?.total) {        
        setTotalDurationPhysicalIntervention(totalDurationPhysicalIntervention)

        // convert minutes to a string with hours and minutes
        const totalDurationPhysicalInterventionValue = totalDurationPhysicalIntervention?.value?.[0]?.total
        const totalDurationPhysicalInterventionHours = Math.floor(totalDurationPhysicalInterventionValue / 60)
        const totalDurationPhysicalInterventionMinutes = totalDurationPhysicalInterventionValue % 60
        const totalDurationPhysicalInterventionLabel = totalDurationPhysicalInterventionHours + 'h ' + totalDurationPhysicalInterventionMinutes + 'm'
        setTotalDurationPhysicalInterventionLabel(totalDurationPhysicalInterventionLabel)

      }
    }

    if (props?.reportData?.breathingMonitoredByStudentGraph) {
      const breathingMonitoredByStudentGraph = props?.reportData?.breathingMonitoredByStudentGraph

      const breathingMonitoredByStudentGraphLabels = []
      const breathingMonitoredByStudentGraphData = []

      for (let x in breathingMonitoredByStudentGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByStudentGraphLabels.push((breathingMonitoredByStudentGraph[x].name || 'n/a'))
        breathingMonitoredByStudentGraphData.push(breathingMonitoredByStudentGraph[x].count)
      }

      setBreathingMonitoredByStudentGraph([breathingMonitoredByStudentGraphData, breathingMonitoredByStudentGraphLabels])
    }

    if (props?.reportData?.breathingMonitoredByYearGroupGraph) {
      const breathingMonitoredByYearGroupGraph = props?.reportData?.breathingMonitoredByYearGroupGraph

      const breathingMonitoredByYearGroupGraphLabels = []
      const breathingMonitoredByYearGroupGraphData = []

      for (let x in breathingMonitoredByYearGroupGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByYearGroupGraphLabels.push((breathingMonitoredByYearGroupGraph[x].name || 'n/a'))
        breathingMonitoredByYearGroupGraphData.push(breathingMonitoredByYearGroupGraph[x].count)
      }

      setBreathingMonitoredByYearGroupGraph([breathingMonitoredByYearGroupGraphData, breathingMonitoredByYearGroupGraphLabels])
    }

    if (props?.reportData?.breathingMonitoredByStudentGroupGraph) {
      const breathingMonitoredByStudentGroupGraph = props?.reportData?.breathingMonitoredByStudentGroupGraph

      const breathingMonitoredByStudentGroupGraphLabels = []
      const breathingMonitoredByStudentGroupGraphData = []

      for (var x in breathingMonitoredByStudentGroupGraph) {
        if (x === 'null') { x = null }
        breathingMonitoredByStudentGroupGraphLabels.push((breathingMonitoredByStudentGroupGraph[x].groupname || 'n/a'))
        breathingMonitoredByStudentGroupGraphData.push(breathingMonitoredByStudentGroupGraph[x].count)
      }

      setBreathingMonitoredByStudentGroupGraph([breathingMonitoredByStudentGroupGraphData, breathingMonitoredByStudentGroupGraphLabels])
    }

    // Restricted Physical Intervension
    if (props?.reportData?.numberIncidentsRestrictedInterventionUsed) {
      setNumIncidentsRestrictedInterventionUsed(props?.reportData?.numberIncidentsRestrictedInterventionUsed)
    }

    // incidentDamageCount
    const incidentDamageCount = props?.reportData?.incidentDamageCount
    if (incidentDamageCount?.length) {
      const incidentDamageCountLabels = incidentDamageCount.map((data, index) => {

        var label = 'n/a'
        switch (data.questionKey) {
          case 'hurtingSelf':
            label = 'Hurting self'
            break
          case 'hurtingOthers':
            label = 'Hurting others'
            break
          case 'propertyDamage':
            label = 'Damage to property'
            break
          case 'commitOffence':
            label = 'Committing an offence'
            break
          case 'behaviour':
            label = 'Behaviour we are trying to support'
            break
        }


        return label
      })
      const incidentDamageCountValue = incidentDamageCount.map((data, index) => {
        return data.count
      })
      setIncidentDamageCountData([incidentDamageCountValue, incidentDamageCountLabels])
    }

    // if (props?.reportData?.incidentSearch) {
    //   setRelatedIncidents(props.reportData.incidentSearch);
    // }
  }, [props.reportData])

  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto', 'auto'],
            large: ['auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto']
          }}
          gap='small'
        >

          <ActionList
              border={false}
              title='Most Common Locations for Intervention'
              pad={{ horizontal: 'none', vertical: 'xsmall' }}
              data={commonInterventions}
              onClick={(item) => {
                props.addFilter(item.key, item.response, item.operator)
              }}
            />

          <ActionList
            border={false}
            pad={{ horizontal: 'none', vertical: 'xsmall' }}
            data={commonPhysicalTechniques}
            title='Most Frequent Physical Techniques'
            onClick={(item) => {
              props.addFilter(item.key, '', 'exists')
            }}
          />

          <ActionList
              border={false}
              pad={{ horizontal: 'none', vertical: 'xsmall' }}
              data={commonDeescalationTechniques}
              title='Most Frequent Deescalation Technique'
              onClick={(item) => {
                props.addFilter(item.key, '', 'exists')
              }}
            />


          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <SimpleCounter count={String(numIncidentsRestrictedInterventionUsed || 0)} label='Incidents involving restrictive physical intervention' />

          </Box>
          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <Box
              background='white'
              direction='column'
              flex='grow'
              pad='small'
              // height='xsmall'
              round='small'
            >
              <Text size='xxlarge' weight='bold' color='besmartBlue'>
                {averageDurationPhysicalInterventionLabel || 'n/a'} </Text>
              <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
              <Text size='small'>Avg. Duration of Physical Interventions</Text>
            </Box>

          </Box>
          <Box
            direction='column'
            flex='grow'
            gap='medium'
          >

            <Box
              background='white'
              direction='column'
              flex='grow'
              pad='small'
              // height='xsmall'
              round='small'
            >
              <Text size='xxlarge' weight='bold' color='besmartBlue'>{totalDurationPhysicalInterventionLabel} </Text>
              <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
              <Text size='small'>Total Duration of Physical Interventions</Text>
            </Box>
          </Box>
         
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >

          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>Total Number of Incidents</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
            <Bar
              data={damageReportChartData}
              height={25}
              legend={{ display: false }}
              // options={{ maintainAspectRatio: false }}
              width={50}
              // onElementsClick={(event) => {
              //   const { _datasetIndex, _index } = event[0];
              //   let key = 'location';
              //   let value = props?.reportData?.totalNumberOfIncidentsByLocation?.[_index]?.response
              //   props.addFilter(key, value);
              // }}
            />
          </Box>
        </ResponsiveGrid>
    </Box>
  )
}

export default InterventionReport
